
import React, { useContext, useState } from "react"
import styled from "@emotion/styled"
import { Wrapper, DescriptionWrapper, Title, ReadMore, Label, InfoWrapper, Holder, List, ListItem } from "../MiniHeaderWorks/styles"
import { PiDotOutlineDuotone, PiLinkBold } from 'react-icons/pi';
import { renderRichText } from 'gatsby-source-contentful/rich-text'


const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
`;

const AccordionComponent = styled.div`
  width: 100%;
  background-color: ${(props) => (props.disabled ? 'gray' : 'transparent')};
  border-radius: 1px;
 /*  box-shadow: 0 1px 3px gray; */
  margin: 0.1em 0em;
`;

const TitleWrapper = styled.div`
  cursor: ${(props) => (props.disabled ? 'wait' : 'pointer')};
  display: flex;
  justify-content: space-between;
  align-items: center;
 
  text-transform:uppercase;
  border-bottom:  1px solid ${(props) => (props.active ? '#333' : '#fff')};
  margin: 0 0em;
  margin-bottom: ${(props) => (props.active ? '1rem' : '0')};
  transition: all 0.5s ease-in-out;
  h3 {
    font-size:1rem;
    font-weight:400;
    margin:0;
  }
`;

const ContentWrapper = styled.div`
  height: 0;
  max-height: 0;
  overflow: auto;
  transition: all 0.5s ease-in-out;
  visibility: hidden;
  overflow-y: auto;
  margin-bottom: ${(props) => (props.active ? '1rem' : '0')};
  p {
    margin-left: 0em;
  }
  ${({ active }) =>
        active &&
        `height:100%;
        max-height: 60vh;
        visibility: visible;
   `}
`;

const ArrowIcon = styled.div`
  transition: transform 0.5s ease-in-out;
  ${({ active, disabled }) =>
        active &&
        !disabled &&
        `
  transform: rotate(180deg);
  transition: all 0.5s ease-in-out;
`}
`;

const Accordion = ({ data }) => {

    let accordionData = data;



    return (
        <AccordionWrapper>
            {accordionData.map((item, index) => (
                <AccordionItem title={item.title} content={item.content} contentType={item.contentType} disabled={item.disabled} key={index} />
            ))}
        </AccordionWrapper>

    )
}

function AccordionItem({ title, content, contentType, disabled }) {
    console.log("AccordionItem", title,)
    const [active, setActive] = React.useState(false);
    const handleToggle = () => {
        setActive((prev) => !prev);
    };

    return (
        <AccordionComponent disabled={disabled}>
            <TitleWrapper onClick={handleToggle} active={active} disabled={disabled}>
                {disabled ? <h3>Accordion Disabled</h3> : <h3>{title}</h3>}
                <ArrowIcon active={active} disabled={disabled}>
                    {'^'}
                </ArrowIcon>
            </TitleWrapper>
            {!disabled && (
                <ContentWrapper active={active}>
                    {contentType == "publications" && (<List expanded={true} >
                        {content && content.map((el, index) => {
                            return <ListItem className={contentType}  key={index}>
                                <span className="icon"><PiDotOutlineDuotone /></span>
                                {el.pdf ? (<><a className="node"  target="_blank" href={el.pdf.file.url}>
                                    <span>{el.magazine}</span>
                                    <span>{el.title}</span>
                                </a></>)
                                    :
                                    el.url ?
                                        <><a className="node"  href={el.url}>
                                            <span>{el.magazine}</span>
                                            <span>{el.title}</span>
                                        </a></>
                                        :
                                        <div className="node" >
                                            <span>{el.magazine}</span>
                                            <span >{el.title}</span>
                                        </div>
                                }
                            </ListItem>
                        })}

                    </List>)}
                    {contentType == "exhibitions" && (<List expanded={true}>

                        {content && content.map((el, index) => {

                            return <ListItem className={contentType}  key={index}>
                                <span className="icon"><PiDotOutlineDuotone /></span>
                                {el.urk ? (<a className="node" target="_blank" href={el.url}>
                                    <span>{el.name}</span>
                                    {el.location ? (<span>{el.location}</span>) : ""}
                                </a>)
                                    :
                                    <div className="node">
                                        <span >{el.name}</span>
                                        {el.location ? (<span className="location">{el.location}</span>) : ""}
                                    </div>}
                            </ListItem>
                        })}

                    </List>)}
                    {contentType == "awards" && (<List expanded={true}>
                        {content && content.map((el, index) => {
                            return <ListItem className={contentType}  key={index}>
                                <span className="icon"><PiDotOutlineDuotone /></span>
                                {el.url ? (<a className="node"  target="_blank" href={el.url}>
                                    <span>{el.name}</span>
                                </a>)
                                    :
                                    <div className="node" >
                                        <span >{el.name}</span>
                                    </div>}
                            </ListItem>
                        })}

                    </List>)}
                    {contentType == "description" &&  (<DescriptionWrapper expanded={true}>
                            {
                              //renderRichText(descOpen ? description : descriptionShort)
                              renderRichText(content)
                            }
                          </DescriptionWrapper>
                        
                    )}
                    
                </ContentWrapper>
            )}
        </AccordionComponent>
    );
}

/* AccordionItem.defaultProps = {
    title: 'Title',
    content: 'content',
}; */

export default Accordion
